import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { ApiHandlerDiscreteParameter, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { UpdateAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { AddCartLinesApiParameter } from "@insite/client-framework/Services/CartService";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SaveCurrentAccount";
import { PopulateAddLineCollectionApiParameter } from "@insite/client-framework/Store/Pages/SavedOrderDetails/Handlers/PlaceOrder";
import { AccountModel, CartLineModel } from "@insite/client-framework/Types/ApiModels";

export interface UserPOInterface extends HasOnSuccess {
    jobfunction: string;
    occupation: string;
    company: string;
    units: string;
    capacity: string;
    language: string;
    chooseCountry: string;
    pressure: string;
    branch: string;
    firstName: string;
    lastName: string;
    userType: string;
    phoneNo: string;
}

type HandlerType = ApiHandlerDiscreteParameter<
    HasOnSuccess & HasOnError<string> & { currentPassword?: string } & UserPOInterface,
    UpdateAccountApiParameter,
    AccountModel,
    { account: AccountModel }
>;

export const ExtendedPopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.apiParameter,
        account: {
            ...props.apiParameter.account,
            firstName: props.parameter.firstName,
            lastName: props.parameter.lastName,

            properties: {
                ...props.apiParameter.account.properties,
                company: props.parameter.company,
                jobfunction: props.parameter.jobfunction,
                occupation: props.parameter.occupation,
                units: props.parameter.units,
                capacity: props.parameter.capacity,
                language: props.parameter.language,
                pressure: props.parameter.pressure,
                branch: props.parameter.branch,
                chooseCountry: props.parameter.chooseCountry,
                userType: props.parameter.userType,
                phoneNo: props.parameter.phoneNo,
            },
        },
    };
};

addToChainAfter(chain, PopulateApiParameter, ExtendedPopulateApiParameter);
